import { Button, Icon, IconButton, Modal, ModalContent } from '@toctoc/design-system';
import { ContactStatusModalProps } from './ContactStatusModal.interface'
import styles from './ContactStatusModal.module.scss';
import { useEffect } from 'react';

export const ContactStatusModal = (props: ContactStatusModalProps) => {
	const { showModal, isMobile, contactStatusModalHandler, leadStatusInfo, userData } = props ?? {};
	const { success, message } = leadStatusInfo ?? {};
	const { name, email } = userData ?? {};

	const closeHandler = () => {
		contactStatusModalHandler(false);
	}

	useEffect(() => {
		if (!showModal) return;
		setTimeout(() => {
			if (showModal) {
				contactStatusModalHandler(false);
			}
		}, 5000)
	}, [showModal]);

	return (
		<Modal open={showModal} claseAux={styles.contactStatusModal} handleClose={closeHandler} maxWidth='xl'>
			<ModalContent>
				{success ? 
					<div className={styles.mainC}>
						<section className={styles.closeButtonC}>
							<IconButton className='btn-cerrar-modal' onClick={closeHandler}>
								<Icon name='close' size={isMobile ? 16 : 24} color='#343A40'/>
							</IconButton>
						</section>
						<section className={styles.modalBodyC}>
							<div className={styles.IconC}>
								<Icon name='check-circle' size={isMobile ? 48 : 72} color='#23AD63' />
							</div>
							<div className={styles.title}>
								<span><strong>¡Muchas gracias por tu contacto!</strong></span>
							</div>
							<div className={styles.successfulDescription}>
								<span>Datos enviados</span>
								<span><strong>Nombre:</strong> {name}</span>
								<span><strong>Correo:</strong> {email}</span>
							</div>
						</section>
						<section className={styles.buttonC}>
							<Button size='small' texto='Aceptar' variant='text' style={{ fontSize: '16px' }} onClick={closeHandler} />
						</section>
					</div>
					: <div className={styles.mainC}>
						<section className={styles.closeButtonC}>
							<IconButton className='btn-cerrar-modal' onClick={closeHandler}>
								<Icon name='close' size={isMobile ? 16 : 24} color='#343A40'/>
							</IconButton>
						</section>
						<section className={styles.modalBodyC}>
							<div className={styles.IconC}>
								<Icon name='SmileySad' size={isMobile ? 48 : 72} color='#E63946' />
							</div>
							<div className={styles.title}>
								<span><strong>¡Lo sentimos!</strong></span>
								<span><strong>No se pudo realizar el contacto</strong></span>
							</div>
							<div className={styles.description}>
								<span>{message}</span>
							</div>
						</section>
						<section className={styles.buttonC}>
							<Button size='small' texto='Aceptar' variant='text' style={{ fontSize: '16px' }} onClick={closeHandler} />
						</section>
					</div>}
			</ModalContent>
		</Modal>
	)
}